import { z } from 'zod'

export const editSnmpDeviceSchema = z.object({
  ipAddress: z.string(),
  port: z.number(),
  community: z.string(),
})

export type TEditSnmpDeviceFields = z.infer<typeof editSnmpDeviceSchema>
